import axios from 'axios';
import { pathOr } from 'ramda';

import { shoppingClubUrl as shoppingClubConfigUrl } from '../api-urls';
import { getCookie } from '../../commons/cookie';
import onlyNumbers from '../../commons/utils/only-numbers';

const defaultErrorMsg =
  'Ocorreu falha na operação. Nosso serviço pode estar temporariamente com problemas. Tente novamente mais tarde!';

const requestAssociateCustomer = ({ cpf, password, acceptedTerms }) => {
  const customerId = getCookie('customerId');
  const customerToken = getCookie('customerToken');
  // shoppingClub está na config de aemp para evitar conflitos. Ela não é utilizada em aemp.
  const shoppingClubUrl = shoppingClubConfigUrl.replace(':customerId', customerId);
  return {
    url: shoppingClubUrl,
    method: 'post',
    headers: { 'Access-Token': customerToken },
    data: {
      document: onlyNumbers(cpf),
      password,
      acceptedTerms
    }
  };
};

const getErrosMessage = errors =>
  errors.reduce((acc, item) => {
    const { fieldName, message } = item;
    acc[fieldName] = message;
    return acc;
  }, {});

export const associateShoppingClub = async ({ cpf, password, acceptedTerms }) => {
  try {
    const response = await axios(requestAssociateCustomer({ cpf, password, acceptedTerms }));
    return { response };
  } catch (err) {
    const { httpStatusCode, validationErrors } = pathOr({}, ['response', 'data'], err);

    switch (httpStatusCode) {
      case 400:
      case 401:
        return { errors: { errorMessage: 'CPF ou senha incorretos' } };

      case 409:
        return { errors: { errorMessage: 'Cliente já cadastrado no clube de compras' } };

      case 422:
        return { errors: getErrosMessage(validationErrors) };

      case 429:
        return {
          errors: { errorMessage: 'Limite de tentativas atingido. Tente novamente mais tarde.' }
        };

      default:
        return { errors: { errorMessage: defaultErrorMsg } };
    }
  }
};
